import * as React from "react";

import { PurchaseForm } from "../providers";

interface GiftcardProductProps {
  giftcardAddedToBag: PurchaseForm;
}

export const GiftcardProduct: React.FunctionComponent<GiftcardProductProps> = (
  props
) => {
  const { giftcardAddedToBag } = props;
  const presentableGiftcardAmount = React.useMemo(() => {
    const value = giftcardAddedToBag?.giftcardAmount;

    const valueAsFloat = parseFloat(value || "");

    const valueAsFloatWithFixedDecimal = valueAsFloat.toFixed(2);

    const asDollarValueString = `$${valueAsFloatWithFixedDecimal}`;

    return asDollarValueString;
  }, [giftcardAddedToBag]);
  return (
    <div className="product e-giftcard-product-special-case">
      <div className="left">
        <div className="product-image-center-alignment-container">
          <div className="product-image-aspect-ratio-container">
            <img className="product-image-photo" width="120px" height="120px"/>
          </div>
        </div>
      </div>
      <div className="right">
        <div className="center-alignment-container">
          <h4>E-Gift Card</h4>
          <div className="greater-price-container no-member-price">
            <div className="price-box price-final_price">
              <span className="price-container price-final_price tax weee">
                <span className="price-wrapper ">
                  <span className="price">{presentableGiftcardAmount}</span>
                </span>
              </span>
            </div>
          </div>
          <p className="send-to">
            Send to: {giftcardAddedToBag?.emailAddress || ""}
          </p>
        </div>
      </div>
    </div>
  );
};
